module.exports = __webpack_public_path__ + "static/media/provider_dash_icon.47ff16db.svg";